export default "__VITE_ASSET__BHpGhgtf__"